import { PlusOutlined } from '@ant-design/icons';
import { Button, Col, Row, Tabs } from "antd";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import { ContentHeader } from "../../components";
import ModalTextForm from '../../components/modal/ModalTextForm';
import { Links } from '../../helpers/Links';
import { menuHelper } from '../../helpers/account';
import { BacLuongResponse, ChiTietHopDongResponse, HopDong, PhuCapResponse } from "../../models/hopdong/HopDong";
import { NhanVienResponse } from '../../models/nhanvien/NhanVien';
import { layCTHopDong, layDanhSachPhuCapTheoHDvaQDBL, layDsHopDongTheoIdNhanVien, xoaHopDong } from "../../services/hopdong";
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import NhanVienHopDongBox from '../nhanvien/NhanVienHopDongBox';
import DanhSachHopDongBox from './DanhSachHopDongBox';
import LuuHopDongBox from './LuuHopDongBox';
import PhuCapBox from './PhuCapBox';
import QuyetDinhBatLuongBox from './QuyetDinhBatLuongBox';

const XemChiTietHopDong = () => {
    let navigate = useNavigate();
    const [defaultSelectBacLuong, setDefaultSelectBacLuong] = useState<BacLuongResponse | undefined>(undefined);
    const [reloadPage, setReloadPage] = useState(false);
    const [reloadPhuCap, setReloadPhuCap] = useState(false);
    const [reloadDsHopDong, setReloadDsHopDong] = useState(false);
    const menu: any = menuHelper.checkMultiPermission([Links.HopDong.ChiTiet]);
    const [showLuuHopDong, setShowLuuHopDong] = useState(false);
    const [idHopDong, setIdHopDong] = useState<number>(0);
    const [idQDBL, setIdQDBL] = useState<number>(0);
    const [idXoaHopDong, setIdXoaHopDong] = useState<number>(0);
    const [dsHopDong, setDsHopDong] = useState<Array<HopDong>>([]);
    const [dsPhuCap, setDsPhuCap] = useState<Array<PhuCapResponse>>([]);
    const [modelProps, setModelProps] = useState<ChiTietHopDongResponse | null>(null);
    const [hopDongInfo, setHopDongInfo] = useState<ChiTietHopDongResponse>(new ChiTietHopDongResponse);
    const [nhanVien, setNhanVien] = useState<NhanVienResponse>(new NhanVienResponse);
    const dispatch = useDispatch();
    // idQuyetDinhBacLuong lấy từ query string, chỉ áp dụng cho lần tải đầu tiên
    const idQDBLParam = useRef<number>(0);

    const layChiTiet = async (id: number) => {
        if (id > 0) {
            var rs = await layCTHopDong(id);
            setHopDongInfo(rs);
            if (rs.bacLuong.length > 0) {
                let selectDefault = rs.bacLuong.find(x => x.idQuyetDinhBacLuong === idQDBLParam.current)
                    || rs.bacLuong[0];
                idQDBLParam.current = 0;
                setIdQDBL(selectDefault.idQuyetDinhBacLuong);
                setDefaultSelectBacLuong(selectDefault)
                setReloadPhuCap(true);
            } else {
                setIdQDBL(0);
                setDefaultSelectBacLuong(undefined);
                setDsPhuCap([]);
            }
        }
    };

    const layDsPhuCap = async (idHopDong: number, idQDBL: number) => {
        dispatch(showLoadingScreen());
        try {
            var data = await layDanhSachPhuCapTheoHDvaQDBL(idHopDong, idQDBL);
            setDsPhuCap(data);
        }
        catch (err: any) {
            toast.error(err.message || "Lấy dữ liệu phụ cấp không thành công");
        }
        dispatch(hideLoadingScreen());
    }

    const layDsHopDong = async (idNV: number, idHopDongChon?: number) => {
        try {
            dispatch(showLoadingScreen());
            if (idNV > 0) {
                var rs = await layDsHopDongTheoIdNhanVien(idNV);
                if (rs.dsHopDong.length > 0) {
                    if (modelProps == null) {
                        let idChon = idHopDongChon || idHopDong;
                        let selectDefault = rs.dsHopDong.find(x => x.id === idChon)
                            || rs.dsHopDong.find(x => x.trangThai === 1)
                            || rs.dsHopDong[0];
                        setIdHopDong(selectDefault.id);
                        setReloadPage(true);
                    }
                } else {
                    setIdHopDong(0);
                    setHopDongInfo(new ChiTietHopDongResponse);
                }
                setDsHopDong(rs.dsHopDong);
                setNhanVien(rs.nhanVienInfo);
            }
            dispatch(hideLoadingScreen());
        }
        catch (error: any) {
            toast.error('Có lỗi xảy ra, hãy thử lại sau!')
            navigate(Links.HopDong.DanhSach);
            dispatch(hideLoadingScreen());
        }
    };

    const xoaHopDongFE = async () => {
        try {
            dispatch(showLoadingScreen());
            await xoaHopDong(idXoaHopDong);
            toast.success('Xoá hợp đồng thành công!');
        }
        catch (err: any) {
            toast.error('Đã xảy ra lỗi, xoá không thành công!');
        }
        setModelProps(null);
        setIdXoaHopDong(0);
        dispatch(hideLoadingScreen());
        setReloadDsHopDong(true);
    }

    useEffect(() => {
        const params = new URLSearchParams(window.location.search)
        let id = params.get('id') || '';
        let idHD = parseInt(params.get('idHopDong') || '') || 0;
        if (idHD > 0) {
            setIdHopDong(idHD);
            idQDBLParam.current = parseInt(params.get('idQDBL') || '') || 0;
        }
        if (parseInt(id) > 0) {
            dispatch(showLoadingScreen());
            layDsHopDong(parseInt(id), idHD);
        };
        dispatch(hideLoadingScreen());
    }, [])

    useEffect(() => {
        if (reloadPage) {
            layChiTiet(idHopDong);
            setReloadPage(false);
        }
    }, [reloadPage])

    useEffect(() => {
        if (reloadDsHopDong) {
            dispatch(showLoadingScreen());
            if (nhanVien != null) {
                layDsHopDong(nhanVien?.id);
                if (modelProps != null) {
                    setIdHopDong(modelProps?.id)
                    setReloadPage(true);
                }
            }
            dispatch(hideLoadingScreen());
            setReloadDsHopDong(false);
        }
        setReloadDsHopDong(false);
    }, [reloadDsHopDong])

    useEffect(() => {
        if (reloadPhuCap) {
            layDsPhuCap(idHopDong, idQDBL);
            setReloadPhuCap(false);
        }
    }, [reloadPhuCap])

    return (
        <section >
            {showLuuHopDong &&
                <LuuHopDongBox
                    modelProps={modelProps}
                    title="Lưu hợp đồng/Quyết định bổ nhiệm"
                    show={showLuuHopDong}
                    idNhanVien={nhanVien?.id}
                    onClose={() => setShowLuuHopDong(false)}
                    onSubmit={() => setReloadDsHopDong(true)} />}
            {idXoaHopDong > 0 && <ModalTextForm show={idXoaHopDong > 0}
                title="Xoá hợp đồng/Quyết định bổ nhiệm"
                handleClose={() => setIdXoaHopDong(0)}
                handleSave={() => xoaHopDongFE()}>
                Xác nhận xoá hợp đồng/Quyết định bổ nhiệm
            </ModalTextForm>}
            <ContentHeader title="Hợp đồng/Quyết định bổ nhiệm" />
            <Row>
                <Col span="24">
                    <div className="card-outline">
                        <Tabs defaultActiveKey="1" items={[
                            {
                                key: '1',
                                label: 'Thông tin cá nhân',
                                children: <NhanVienHopDongBox nhanVien={nhanVien} />
                            },
                        ]}>
                        </Tabs>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col span="24">
                    <div className="card-outline">
                        <Tabs
                            tabBarExtraContent={menu[Links.HopDong.ChiTiet] ?
                                    <Button
                                        onClick={() => {
                                            setShowLuuHopDong(true);
                                            setModelProps(null);
                                        }}
                                        icon={<PlusOutlined rev="" />}
                                        className="hrm-btn hrm-btn-warning"
                                    >
                                        Thêm mới
                                    </Button>
                                    : null
                            } defaultActiveKey="1" items={[
                                {
                                    key: '1',
                                    label: 'Danh sách hợp đồng/quyết định bổ nhiệm',
                                    children:
                                        <Col span="24" className="card qlns-search-box">
                                            <DanhSachHopDongBox defaultSelect={(dsHopDong || []).length > 0 ? modelProps != null ? dsHopDong?.find(x => x.id == modelProps.id) : (dsHopDong?.find(x => x.id == idHopDong) || dsHopDong[0]) : undefined}
                                                listData={dsHopDong} select={true}
                                                isThemMoi={menu[Links.HopDong.ChiTiet]}
                                                hopDongInfo={hopDongInfo}
                                                onSubmit={() => { setIdHopDong(0); setReloadDsHopDong(true); setReloadPage(true); }}
                                                idNhanVien={nhanVien?.id}
                                                onRowSelected={(e: HopDong) => {
                                                    setIdHopDong(e?.id);
                                                    setReloadPage(true);/*
                                                const element = document.getElementById("detail-hopdong");
                                                element?.scrollIntoView({ behavior: 'smooth' })*/
                                            }} />
                                        </Col>
                                },
                            ]}>
                        </Tabs>
                    </div>
                </Col>
            </Row>
            {idHopDong > 0 &&
                <>{/*
                    <Row>
                        <Col span="24">
                            <div className="card-outline" id="detail-hopdong">
                                <Tabs
                                    defaultActiveKey="1" items={[
                                        {
                                            key: '1',
                                            label: 'Thông tin hợp đồng/quyết định bổ nhiệm',
                                            children: <div className="card pl-2">
                                                <div className="card-body">
                                                    <Col span="24" className="form-group row">
                                                        <Col span="6" className="form-group">
                                                            <div>Số hợp đồng/quyết định bổ nhiệm</div>
                                                            <label>
                                                                <Space>
                                                                    {hopDongInfo?.soHopDong}
                                                                    <Tag color={hopDongInfo?.trangThai ? "green" : "red"}>{hopDongInfo?.trangThai ? "Hiệu lực" : "Hết hiệu lực"}</Tag>
                                                                </Space>
                                                            </label>
                                                        </Col>
                                                        <Col span="6" className="form-group">
                                                            <div>Loại hợp đồng/quyết định bổ nhiệm</div>
                                                            <label>{hopDongInfo?.loaiHopDong}</label>
                                                        </Col>
                                                        <Col span="6" className="form-group">
                                                            <div>Ngày ký hợp đồng/quyết định bổ nhiệm</div>
                                                            <label>{dateCommon.formatDate(hopDongInfo?.ngayKy)}</label>
                                                        </Col>
                                                        <Col span="6" className="form-group">
                                                            <div>Nơi ký</div>
                                                            <label>{hopDongInfo?.noiKy}</label>
                                                        </Col>
                                                    </Col>
                                                    <Col span="24" className="form-group row">
                                                        <Col span="6" className="form-group">
                                                            <div>Từ ngày</div>
                                                            <label>{dateCommon.formatDate(hopDongInfo?.ngayBatDau)}</label>
                                                        </Col>
                                                        <Col span="6" className="form-group">
                                                            <div>Đến ngày</div>
                                                            <label>{dateCommon.formatDate(hopDongInfo?.ngayKetThuc)}</label>
                                                        </Col>
                                                        <Col span="6" className="form-group">
                                                            <div>Người ký</div>
                                                            <label>{hopDongInfo?.tenNguoiKy}</label>
                                                        </Col>
                                                        <Col span="6" className="form-group">
                                                            <div>Đóng BHXH</div>
                                                            <label><Tag color={hopDongInfo?.isDongBHXH ? "green" : "red"}>{hopDongInfo?.isDongBHXH ? "Đóng" : "Không đóng"}</Tag></label>
                                                        </Col>
                                                    </Col>
                                                    <Col span="24" className="form-group row">
                                                        <Col span="12" className="form-group">
                                                            <div>Hợp đồng/Quyết định bổ nhiệm đính kèm</div>
                                                            <Table
                                                                locale={{ emptyText: "Không có dữ liệu" }}
                                                                pagination={false} size='small'
                                                                dataSource={(hopDongInfo?.dsTaiLieu || []).map((value, index) => { const item = { key: index, ...value }; return item; })}
                                                            >
                                                                <Column
                                                                    title="STT"
                                                                    key="STT"
                                                                    align="center"
                                                                    render={(value, record, index) =>
                                                                    (
                                                                        <>
                                                                            {index + 1}
                                                                        </>
                                                                    )
                                                                    }
                                                                />
                                                                <Column title="Tên tài liệu" key="tenTep" render={(value, record, index) => (
                                                                    <p>{value?.tenTep?.replace(/^.*[\\/]/, '')}</p>
                                                                )} />
                                                                <Column title="Xem" key="Xem"
                                                                    render={(value, record, index) =>
                                                                    (
                                                                        <>
                                                                            <Button className="hrm-btn hrm-btn-sm hrm-btn-success" title="Xem" onClick={() => {
                                                                                window.open(urlAdmin + value?.duongDan?.replace(/\\/g, "/"), '_blank')
                                                                                //window.open(value?.duongDan?.replace("View\\public", "").replace(/\\/g, "/"), '_blank')
                                                                            }}><i className="fa fa-eye mr-2" />Xem</Button>
                                                                        </>
                                                                    )
                                                                    }
                                                                />
                                                                <Column title="Tải xuống" key="Xem"
                                                                    render={(value, record, index) =>
                                                                    (
                                                                        <>
                                                                            <a href={urlAdmin + value?.duongDan?.replace(/\\/g, "/")} download>
                                                                                <Button className="hrm-btn hrm-btn-sm hrm-btn-success" title="Tải xuống">
                                                                                    <i className="fa fa-download mr-2" />Tải xuống
                                                                                </Button>
                                                                            </a>
                                                                        </>
                                                                        //<>
                                                                        //    <Link to={value?.duongDan?.replace("View\\public", "").replace(/\\/g, "/")} target="_blank" download>
                                                                        //        <Button className="hrm-btn hrm-btn-sm btn-success" title="Tải xuống">
                                                                        //            <i className="fa fa-download mr-2" />Tải xuống
                                                                        //        </Button>
                                                                        //    </Link>
                                                                        //</>
                                                                    )
                                                                    }
                                                                />
                                                            </Table>
                                                        </Col>
                                                    </Col>
                                                </div>
                                                <div className="card-footer">
                                                    <Space className="float-right">
                                                        <Button
                                                            type="primary"
                                                            size={"small"}
                                                            icon=<EditOutlined rev="" />
                                                            onClick={() => {
                                                                setModelProps(hopDongInfo);
                                                                setShowLuuHopDong(true);
                                                            }}>Sửa</Button>
                                                        <Button
                                                            type="primary"
                                                            size={"small"}
                                                            danger
                                                            icon=<DeleteOutlined rev="" />
                                                            onClick={() =>
                                                                setIdXoaHopDong(hopDongInfo?.id)}
                                                        >Xoá</Button>
                                                    </Space>

                                                </div>
                                            </div>
                                        },
                                    ]}>
                                </Tabs>
                            </div>
                        </Col>
                    </Row>*/}
                    <Row>
                        <Col span="24">
                            <QuyetDinhBatLuongBox idHopDong={idHopDong} listData={hopDongInfo?.bacLuong} isThemMoi={menu[Links.HopDong.ChiTiet]} onSubmit={() => { setReloadPage(true) }}
                                select={true}
                                defaultSelect={defaultSelectBacLuong}
                                onRowSelected={(e: BacLuongResponse) => {
                                    setIdQDBL(e?.idQuyetDinhBacLuong);
                                    setDefaultSelectBacLuong(e);
                                    setReloadPhuCap(true);
                                }} />
                        </Col>
                    </Row>
                    <Row>
                        <Col span="24">
                            <PhuCapBox idQDBL={idQDBL} idHopDong={idHopDong} idChucVu={hopDongInfo?.idChucVu} idDonVi={hopDongInfo?.idDonVi} listData={dsPhuCap} isThemMoi={menu[Links.HopDong.ChiTiet]} onSubmit={() => { setReloadPhuCap(true) }} />
                        </Col>
                    </Row>
                </>}
        </section >
    )
}

export default XemChiTietHopDong